import drEasyApi from "./Customapi";

export async function getPatientInfo(id) {
    try {
        var res = await drEasyApi.get(`/api/Centers/GetPatientInfo?userId=${id}`)
        return res.data

    } catch (err) {
        return err
    }
}